module.exports = __webpack_public_path__ + "img/img13.3683c4af.svg";